<template>
  <v-card
    style="display: flex;padding: 6px 12px;"
    color="#333333"
    class="snack-card"
  >
    <div style="display: flex;align-items: center;">
      <font size="3" color="#FFFFFF" style="white-space:pre-wrap; word-wrap:break-word;">
        {{ message.text }}</font></div>
    <v-spacer></v-spacer>
    <v-btn
      color="#00FFFF"
      text
      @click="remove()"
    >
      <u>Close</u>
    </v-btn>
    <!-- <v-btn
      icon
      depressed
      @click="remove()"
    >
      <v-icon color="rgba(51, 51, 51, 0.3)">cancel</v-icon>
    </v-btn> -->
  </v-card>
</template>

<script>
export default {
  props: {
    message: Object,
  },

  data() {
    return {
      activeTimeout: -1,
    };
  },

  mounted() {
    // メッセージコンポーネントがマウントされた時点からカウント開始
    this.setTimeout();
  },

  methods: {

    setTimeout() {
      window.clearTimeout(this.activeTimeout);
      const { timeout } = this.message.state;
      // タイムアウト時間が設定されている場合は
      if (timeout) {
        // 指定時間後にremoveを呼び出す
        this.activeTimeout = window.setTimeout(() => {
          this.remove();
        }, timeout);
      }
    },

    // 親コンポーネントにremoveを発火
    remove() {
      this.$emit('remove');
    },
  },
};
</script>
<style>
.snack-card {
  width:600px
}
</style>
